module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-left-42fd60df26c3c9fd506ae5b6df98fc6c.svg";